/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
import RPC, { INFO } from '../../RPC/role-permission/API';
import TreeMaker from '../converter/treeMaker';

export { Info as typeInfo };

type crud = number // crud

interface response extends INFO.response {
  node_f: any
  role_node_f: crud[] // 將crud放入陣列，請注意 index = node_id 因此 **empty是存在的**
}

// validate
class Info {
  private request: string;

  constructor(request: string) {
    this.request = request;
  }

  public async get(): Promise<response> {
    const getter = RPC.modify({ p5_role_id: this.request });
    /* render to view */
    return getter
      .then((res: INFO.AxiosResponse) => {

        const result: any = res.data.response;
        result.node_f = formater(res.data.response.node);
        /** 將目前角色的權限格式化並輸出 */
        result.role_node_f = res.data.response.role_node
          .map(role_node_formater)
          .reduce(role_node_reducer, []);
        // FIXME: 觀察一下，empty項目是否需要補上0
        return result;
      });
  }
}


export default Info;

/** 將回傳的總NODE格式化 by NICK */
function formater(node: INFO.node[]) {
  const tree = new TreeMaker(node);
  return tree.result;
}

type node_f = { id: number, crud: number }

/** 回傳的單獨角色權限格式化 */
export function role_node_formater(node: INFO.role_node): node_f {
  const crud = node.crud;
  const id = node.p3_brn_p4_node_id;
  return { crud, id };
}

/**
 * 將該角色的權限與nodeID轉換
 * 變成 **以nodeID為index的陣列**
*/
function role_node_reducer(prev: crud[], cur: node_f): crud[] {
  const reduce = prev;
  const index = cur.id;
  reduce[index] = cur.crud;
  return reduce;
}
